// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__24Fe1","title":"InfoRow_title__pefIu"};